import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken, clearToken } from '../utils/storage';

const isTokenExpired = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp * 1000 < Date.now();
    } catch {
        return true;
    }
};

const ProtectedRoute = ({ children }) => {
    const token = getToken();
    const location = useLocation();

    if (!token || isTokenExpired(token)) {
        clearToken();
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;
